//Main style file
import './assets/scss/main.scss';
export { Accessibility } from './components/Accessibility';